import axios from 'axios'
import { useUserStore } from '@/stores/userStore'
import { JAMS_BACKEND_API_URL, STAGE } from '@/env'

const apiClient = axios.create({
  baseURL: `${JAMS_BACKEND_API_URL}/${STAGE}/client`,
  timeout: 25000,
})

export const axiosInstance = axios.create({
  baseURL: `${JAMS_BACKEND_API_URL}/${STAGE}/client`,
  timeout: 25000,
})

axiosInstance.interceptors.request.use(
  (config) => {
    const userStore = useUserStore()
    if (userStore.token) {
      config.headers['Authorization'] = `Bearer ${userStore.token}`
    }

    // Add product ID and account for usage tracking
    const params = new URLSearchParams(config.params)
    
    // Always set product to 'jams' for JAMS client calls
    params.set('product', 'jams')
    
    // Set account based on user role
    const role = userStore.role as string | null
    if (role && role.startsWith('client_')) {
      // Client users: use their juid
      if (userStore.juid) {
        params.set('account', userStore.juid)
      }
    } else {
      // Company users: use 'jazel'
      params.set('account', 'jazel')
    }
    
    config.params = params

    console.log(config)
    return config
  },
  (error) => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error)

    return Promise.reject(error)
  }
)

export default apiClient
